import {
	FaHashtag,
	FaLink,
	FaCalendarAlt,
	Header,
	FaUserLock,
	FaFolder,
	AppEnum,
	OptionHelper,
	PermissionEnums,
} from "@/Shared";

import { PermissionViewModel } from ".";
import { ResourceAccessHeader } from "./resource-access-config";

/**
 * Configuration des colonnes pour la vue des documents.
 */
export class PermissionHeader {
	private constructor() {}

	get id() {
		return {
			key: "id",
			icon: <FaHashtag />,
			label: "ID",
			type: "number",
			isSortable: true,
		};
	}

	getRole(UserRoleEnum : AppEnum[]) {
		return {
			key: "role",
			icon: <FaUserLock />,
			label: "Rôle",
			type: "string",
			isSortable: true,
			filter: {
				label: "Rôle",
				case: "insensitive",
				options : OptionHelper.sortByLabel(UserRoleEnum)
			},
		};
	}

	getResource(ResourceTypeEnum : AppEnum[]) {
		return {
			key: "resource",
			icon: <FaFolder />,
			label: "resource",
			type: "string",
			isSortable: true,
			filter: {
				label: "Resource",
				case: "insensitive",
				options : OptionHelper.sortByLabel(ResourceTypeEnum)
			},
		};
	}

	get accessList() {
		return {
			key: "accessRightLabels",
			icon: <FaLink />,
			label: "Type d'accès",
			type: "string",
			isSortable: false,
		};
	}

	get creationDate() {
		return {
			key: "creationDate",
			icon: <FaCalendarAlt />,
			label: "Date de création",
			type: "date",
			isSortable: true,
		};
	}

	static build(
		viewEnums: PermissionEnums
	): Record<keyof PermissionViewModel, Header<PermissionViewModel>> {
		const header = new PermissionHeader();

		return {
			id: header.id,
			role: header.getRole(viewEnums.UserRoleEnum),
			creationDate: header.creationDate,
		} as Record<keyof PermissionViewModel, Header<PermissionViewModel>>;
	}
}
